/** Dispatched when the Admin left-rail accordion selects a module secondary tab. */
export const ADMIN_SHELL_NAV_EVENT = "pacehrm:admin-shell-nav";

/** Global Activity Console toggle event (admin shell). */
export const ACTIVITY_CONSOLE_TOGGLE_EVENT = "pacehrm:activity-console-toggle";

const ACTIVITY_CONSOLE_RETURN_KEY = "pacehrm:activity-console-return";

/** Persist where to return when leaving Activity Console via Back. */
export function rememberActivityConsoleReturn(location, pageLabel) {
  if (!location?.pathname) return;
  if (String(location.pathname).startsWith("/admin/activity-console")) return;
  try {
    sessionStorage.setItem(
      ACTIVITY_CONSOLE_RETURN_KEY,
      JSON.stringify({
        pathname: location.pathname,
        search: location.search || "",
        page: pageLabel || null,
        at: Date.now(),
      })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

/** Read and clear the return location for Activity Console Back. */
export function consumeActivityConsoleReturn() {
  try {
    const raw = sessionStorage.getItem(ACTIVITY_CONSOLE_RETURN_KEY);
    sessionStorage.removeItem(ACTIVITY_CONSOLE_RETURN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.pathname) return null;
    return parsed;
  } catch {
    return null;
  }
}
